export const brandValues = {
  'nbcnews.com': {
    reportSuites: 'msnbcnbcnewscomprod',
    server: 'www.nbcnews.com',
    parsely: 'nbcnews.com',
    comscoreC2: '6035083',
    mParticle: '65ea0b28a73c4c4abd08599774d30799',
    nameSpace: 'msnbc',
  },
  'today.com': {
    reportSuites: 'nbcutodaycomprod',
    server: 'www.today.com',
    parsely: 'today.com',
    comscoreC2: '6035083',
    mParticle: '3f8eeba44cd1254a897586bb26fa1c4a',
    nameSpace: 'nbcuniversal',
  },
  'msnbc.com': {
    reportSuites: 'msnbcdotcom',
    server: 'www.msnbc.com',
    parsely: 'msnbc.com',
    comscoreC2: '6035083',
    mParticle: '4c6f61ee9fa74942a781c3ecf77b926e',
    nameSpace: 'msnbc',
  },
  'telemundo.com': {
    comscoreC2: '6035083',
    mParticle: 'us1-09b8a860d541194caaa889a29a469376',
    nameSpace: 'nbcuniversal',
    parsely: '',
    reportSuites: 'nbcutelemundo',
    server: 'www.telemundo.com',
  },
};

export const formatVertical = (vertical) => {
  if (vertical === 'knowyourvalue') {
    return 'know-your-value';
  }
  return vertical;
};

export const parsleyTag = (brandParsely) => {
  let returnBlock = '';
  if (brandParsely) {
    returnBlock = `
<amp-analytics type="parsely">
  <script type="application/json">
    {
      "vars": {
        "apikey": "${brandParsely}"
      }
    }
  </script>
</amp-analytics>
`;
  }
  return returnBlock;
};
